import React from 'react';
import { MapPin, Clock, Instagram, Facebook } from 'lucide-react';
const TiktokIcon = ({
  size = 20
}: {
  size?: number;
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-61">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.81a8.16 8.16 0 0 0 4.77 1.52V6.88a4.85 4.85 0 0 1-1.84-.19z" data-id="element-62" />
  </svg>;
export function Footer() {
  return <footer className="bg-hope-brown text-hope-cream py-16" data-id="element-63">
      <div className="max-w-7xl mx-auto px-6" data-id="element-64">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-65">
          {/* Brand */}
          <div data-id="element-66">
            <div className="flex items-center gap-3 mb-6" data-id="element-67">
              <div className="bg-hope-cream rounded-xl p-3" data-id="element-68">
                <img src="https://cdn.magicpatterns.com/uploads/1GsN8Dz1rZCZJiijDwSn26/logo.png" alt="HOPE Cafetería" className="h-12 w-auto" data-id="element-69" />
              </div>
            </div>
            <p className="text-hope-cream/70 max-w-xs leading-relaxed" data-id="element-70">
              Coffee with a purpose, located inside Centro Comunitario Palabras
              de Esperanza.
            </p>
          </div>

          {/* Info */}
          <div className="space-y-6" data-id="element-71">
            <div className="flex items-start gap-4" data-id="element-72">
              <MapPin className="text-hope-mustard shrink-0 mt-1" size={20} data-id="element-73" />
              <div data-id="element-74">
                <h4 className="font-serif font-bold text-lg mb-1" data-id="element-75">Location</h4>
                <a href="https://www.google.com/maps/place/Hope+Cafeter%C3%ADa/@31.3241927,-113.4847587,17z/data=!3m1!4b1!4m6!3m5!1s0x812ba54b41c86ce7:0x586959299917deea!8m2!3d31.3241881!4d-113.4821838!16s%2Fg%2F11n9s50q84?authuser=0&entry=ttu&g_ep=EgoyMDI2MDUwMi4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="text-hope-cream/70 hover:text-hope-mustard transition-colors" data-id="element-76">
                  Cjón. Juan Aldama, Av. 69 Av. 68, 83557 Puerto Peñasco,
                  <br data-id="element-77" />
                  Son., México
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-78">
              <Clock className="text-hope-mustard shrink-0 mt-1" size={20} data-id="element-79" />
              <div data-id="element-80">
                <h4 className="font-serif font-bold text-lg mb-1" data-id="element-81">Hours</h4>
                <p className="text-hope-cream/70" data-id="element-82">
                  Mon–Sat: 9:00 AM – 6:00 PM
                  <br data-id="element-83" />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>

          {/* Social & Links */}
          <div data-id="element-84">
            <h4 className="font-serif font-bold text-lg mb-4" data-id="element-85">Connect</h4>
            <div className="flex gap-4 mb-8" data-id="element-86">
              <a href="https://www.instagram.com/hope_cafeteria/" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-hope-mustard hover:text-hope-brown transition-colors" data-id="element-87">
                <Instagram size={20} data-id="element-88" />
              </a>
              <a href="https://www.facebook.com/Hope.Cafeteria.Penasco" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-hope-mustard hover:text-hope-brown transition-colors" data-id="element-89">
                <Facebook size={20} data-id="element-90" />
              </a>

              <a href="https://www.tiktok.com/@hope_cafeteria" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-hope-mustard hover:text-hope-brown transition-colors" data-id="element-91">
                <TiktokIcon size={20} data-id="element-92" />
              </a>
            </div>

            <div className="flex flex-col gap-2 text-hope-cream/70" data-id="element-93">
              <a href="#menu" className="hover:text-hope-mustard transition-colors" data-id="element-94">
                Menu
              </a>

              <a href="#about" className="hover:text-hope-mustard transition-colors" data-id="element-95">
                Our Story
              </a>

              <a href="#community" className="hover:text-hope-mustard transition-colors" data-id="element-96">
                Community Center
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-hope-cream/50 text-sm flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-97">
          <p data-id="element-98">
            &copy; {new Date().getFullYear()} HOPE Cafetería. All rights
            reserved.
          </p>
          <p data-id="element-99">Centro Comunitario Palabras de Esperanza</p>
        </div>
      </div>
    </footer>;
}